document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    const $ballImages = document.querySelectorAll(".bndlr-product-image");
    $ballImages.forEach((image) => {
      const title = image.getAttribute("title");
      let src = "";
      let srcSet = "";
      if(title === "White/Blue" || title.includes("White/Blue")) {
        src = "https://cdn.shopify.com/s/files/1/0565/7113/4038/files/Brekkline_3PackwithBall_WhiteBallwithBlue_60d81d60-d131-42c6-a90c-c013832e2950.png?v=1713901008";
        srcSet = "https://cdn.shopify.com/s/files/1/0565/7113/4038/files/Brekkline_3PackwithBall_WhiteBallwithBlue_60d81d60-d131-42c6-a90c-c013832e2950.png?v=1713901008";
      } else if (title === "White/Red" || title.includes("White/Red")) {
        src = "https://cdn.shopify.com/s/files/1/0565/7113/4038/files/Brekkline_3PackwithBall_WhiteBallwithRed_03ec5b07-9ca2-4de1-a4c2-275de1aff508.png?v=1713901008";
        srcSet = "https://cdn.shopify.com/s/files/1/0565/7113/4038/files/Brekkline_3PackwithBall_WhiteBallwithRed_03ec5b07-9ca2-4de1-a4c2-275de1aff508.png?v=1713901008";
      } else if (title === "Yellow/Red" || title.includes("Yellow/Red")) {
        src = "https://cdn.shopify.com/s/files/1/0565/7113/4038/files/Brekkline_3PackwithBall_YellowBall_1d88edcf-cb3a-4e35-9c2c-dc2c4e2b77f3.png?v=1713901008";
        srcSet = "https://cdn.shopify.com/s/files/1/0565/7113/4038/files/Brekkline_3PackwithBall_YellowBall_1d88edcf-cb3a-4e35-9c2c-dc2c4e2b77f3.png?v=1713901008";
      }
      image.setAttribute("src", src);
      image.setAttribute("srcset", srcSet);
    })
  }, 5000);
});